module.exports = __webpack_public_path__ + "static/media/icon-file-doc.b2927ac2.svg";